import { Trans } from "react-i18next";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import {
  Dialog,
  DialogOverlay,
  DialogPortal,
  DialogTitle
} from "../../../components/ui/dialog";
import { X } from "lucide-react";

export function TomorrowPlanModal({ record, onOpenChange }) {
  return (
    <Dialog open={!!record} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay className="bg-[#0a1230]/50 backdrop-blur-sm" />

        <DialogPrimitive.Content
          className="fixed left-[50%] top-[50%] z-50
          translate-x-[-50%] translate-y-[-50%]
          w-[calc(100%-2rem)] max-w-lg
          max-h-[85vh] overflow-y-auto
          rounded-2xl border border-white/60
          bg-white
          shadow-[0_30px_80px_-20px_rgba(30,51,131,0.45)]
          font-sans"
        >
          {record && (
            <>
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-[var(--color-text-border)]/70">
                <div>
                  <DialogTitle className="text-xl font-bold text-foreground">
                    <Trans i18nKey="attendance.tomorrowPlan" />
                  </DialogTitle>

                  <p className="text-sm text-[var(--color-text-secondary)] mt-0.5">
                    {record.empName || "—"}
                    <span className="text-[var(--color-text-border)] mx-1">
                      ·
                    </span>
                    <Trans i18nKey="common.id" /> {record.empId ?? "—"}
                  </p>
                </div>

                <DialogPrimitive.Close
                  className="h-9 w-9 grid place-items-center rounded-xl
                  text-[var(--color-text-secondary)]
                  hover:bg-[var(--color-workspace)]/60
                  hover:text-[var(--color-primary)]
                  transition cursor-pointer"
                >
                  <X className="h-5 w-5" />
                  <span className="sr-only">
                    <Trans i18nKey="formActions.close" />
                  </span>
                </DialogPrimitive.Close>
              </div>

              {/* Tomorrow Plan */}
              <div className="px-6 py-5">
                <div className="rounded-xl border border-[var(--color-text-border)]/60 bg-[var(--color-workspace)]/20 p-4">
                  <p className="text-sm font-semibold text-[var(--color-text-secondary)] mb-2">
                    <Trans i18nKey="attendance.tomorrowPlan" />
                  </p>

                  <p className="text-sm leading-6 text-foreground whitespace-pre-wrap">
                    {record.tomorrowPlan || "—"}
                  </p>
                </div>
              </div>

              <div className="h-2" />
            </>
          )}
        </DialogPrimitive.Content>
      </DialogPortal>
    </Dialog>
  );
}